/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useCallback } from 'react';
import type { EntityLimitType as CollectionEntityLimitType } from '@jira/polaris__domain-collection/src/EntityLimitType.types.tsx';
import type { EntityLimitType as ProjectEntityLimitType } from '@jira/polaris__domain-project/src/ProjectMetadata.types.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { getLimitMessageDescriptor } from './getLimitMessageDescriptor.tsx';

export const useEntityLimitMessage = (): ((
	limitType: ProjectEntityLimitType | CollectionEntityLimitType,
	limitValue: number,
) => string | null) => {
	const { formatMessage } = useIntl();

	return useCallback(
		(limitType: ProjectEntityLimitType | CollectionEntityLimitType, limitValue: number) => {
			const message = getLimitMessageDescriptor(limitType);
			return message ? formatMessage(message, { limit: limitValue }) : null;
		},
		[formatMessage],
	);
};
